import React, { useEffect, useState } from 'react';
import { Card } from 'react-bootstrap';
import { getProfileData,getNotification } from '../services/ProfileService';
import { setLoader } from '../Store/Reducers/UserReducer';
import { useDispatch } from "react-redux";
import { useNavigate } from 'react-router';
import moment from 'moment';
import './ShowProfileData.css';
import LoginFun from '../Layout Component/Loginfun';
import Swal from "sweetalert2";
import axios from "axios";
import $ from "jquery";
import { Skeleton } from "../theme/Skeleton";
export default function ShowProfileData({SetUserData}) {
    debugger
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const url = process.env.REACT_APP_OXAR_API_URL;
    let defaultImage = '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';
    const logindata = LoginFun();
    const [profile, setprofile] = useState();
    const [imgUrl, setImgUrl] = useState("");
    const uID = localStorage.getItem('UserID');
    const [notifications, setNotifications] = useState([]);
    const [open, setOpen] = useState(true);
    const [imgurl, setimgurl] = useState("");
    

    useEffect(() => {
        sessionCheck();
        getProfileDataPreview();
        getNotificationDataPreview();
    }, []);
    const getProfileDataPreview = async () => {
        debugger
            try {
        dispatch(setLoader(true));
        const res = await getProfileData(uID);
        if (res !== undefined) {
            debugger
            if (res.content.birthday != null) {
                res.content.birthday = res.content['birthday'].substring(0, 10);
            }
            if (res.content.entityimage == null) {
                setImgUrl('data:image/png;base64,' + defaultImage);
            }
            else {
                setImgUrl('data:image/png;base64,' + res.content.entityimage);
            }
              if (res.content.bcrm_datemovedtouk != null) {
                res.content.bcrm_datemovedtouk = res.content['bcrm_datemovedtouk'].substring(0, 10);
            }
            setprofile(res.content);
            localStorage.setItem("UData",JSON.stringify(res.content));
            getPartnerData(uID);
        }
        dispatch(setLoader(false));
    }
     catch (e) {
            dispatch(setLoader(false));
             return
            }
    }

    const getNotificationDataPreview = async () => {
        try {
            debugger
            //dispatch(setLoader(true));
            const res = await getNotification(uID);
            if (res !== undefined) {
                debugger
                setNotifications(res.content);
                if(res.content.length == "0" || res.content.length == 0){
                setOpen(false);
                }
            }
            dispatch(setLoader(false));
        }
        catch (e) {
        dispatch(setLoader(false));
        return
        }
    }

    const toggleAcknowledge = async (ID) => {
        debugger
        //dispatch(setLoader(true));
          try {
            const res = await axios.put(`${url}api/Profile/UpdateNotificationForPatient?NotificationID=${ID}`);
            if (res.status === 200) {
                 getNotificationDataPreview();
                dispatch(setLoader(false));
            }
            dispatch(setLoader(false));
        }
        catch (e) {
            dispatch(setLoader(false));
             return
            }
        dispatch(setLoader(false));
        }

     const sessionCheck = async () => {
        var currentTime = ''
        currentTime = (Math.round(new Date().getTime() / 1000));
        var Expiretime = localStorage.getItem("ExpirretokenTime");
        if (Expiretime < currentTime) {
             dispatch(setLoader(false));
            sessionStorage.getItem('isLoggedIn', false)
            Swal.fire({
                title: 'Session Expired',
                text: "Your session has been expired! Please login again",
                icon: 'warning',
                showCancelButton: false,
                confirmButtonText: 'Okay',
            }).then(result => {
                logindata.logout();
            })
        }
    }

      const getPartnerData = async (Id) => {
    try {
      dispatch(setLoader(true));
      let MainUserId = localStorage.getItem("UserID");

      await axios(
        `${url}api/CrmUser/GetRelatedContactByID?Id=${MainUserId}`
      ).then((res) => {
        if (res.data.content != null) {
           //setPartnerData(res.data.content);
          if (res.data.content.entityimage == null) {
            setimgurl(defaultImage);
          }
          else {
            setimgurl(res.data.content.entityimage);
          }
          // setimgurl(res.data.content.entityimage)
          $('#ImageShowonload').show();
          res.data.content.birthdate = res.data.content['birthdate'].substring(0, 10);
          sessionStorage.setItem("ReleatedcontactData",JSON.stringify(res.data.content));
        }

      });
      dispatch(setLoader(false));

    } catch {
      dispatch(setLoader(false));
    }
  };

    return (
        
        <div className="p-2">

            {/* Notification Work */}
                { notifications.length > 0 && (
            <div className="card NotificationCard">
                <div
                    className="card-header d-flex justify-content-between align-items-center"
                    style={{ cursor: "pointer" }}
                    onClick={() => setOpen(!open)}>
                    <div>
                        <b>Notification</b>
                        <span className="badge bg-danger ms-2">
                            {notifications.length}
                        </span>
                    </div>
                    <i
                        className={`fa ${
                            open
                                ? "fa-chevron-up"
                                : "fa-chevron-down"
                        }`}
                    />
                </div>
                {open && (
                    <div className="card-body">
                          <b> Note :- </b> Please click the Documents tab on the left-hand side navigation to review the file. <hr></hr>
                        {notifications.map((item) => (
                            <div key={item.id} className="border-bottom py-2">

         

                                <div className='row'>
                                    
                                <div className='col-md-8'>
                                         <b>{item.message}</b>
                                </div>
                                <div className='col-md-4'>
                                        <div className="d-flex justify-content-end">
                                        <span className="text-muted">
                                            <b>Acknowledge</b>
                                        </span>

                                        <input
                                            type="checkbox" 
                                            className="CheckboxforAcknowledge"
                                            title='Click to acknowledge'
                                            onChange={() =>
                                                toggleAcknowledge(item.id)
                                            }
                                    />
                               </div>
                                </div>
                                </div>
                                {/* <small className="text-muted">
                                    {moment(item.createdOn).format("DD-MMM-yyyy") ? moment(item.createdOn).format("DD-MMM-yyyy") : moment(item.createdOn).format("DD-MMM-yyyy")}
                                </small> */}
                            </div>
                        ))}

                    </div>
                )}
            </div>
             )}
          {/* Notification Work END*/}

            <Card.Header className=" border">
                <div className="row">
                    <div className="col">
                        <h5>Profile</h5> </div><div className="col">
                        <a  className="dropdown-item  nav-link text-primary text-right" id='ankortagShowdata'
                            onClick={() => navigate('/ProfileData')} ><i data-feather="edit-2"
                                className="fa fa-edit"   ></i> <span className="" >
                                &nbsp; Edit</span></a>
                    </div>
                </div>
            </Card.Header>
            <div className="profile-page tx-13 mt-1">
                <div className="row profile-body">
                    <div className="col-md-6">
                        <div className="row">
                            <div className=" d-md-block col-md-12 col-xl-12 left-wrapper">
                                <div className="card rounded border">
                                    <div className="card-body row pt-3 mb-2">
                                        <div className="col-md-6">
                                            <div className="d-flex row justify-content-between pb-1 ">
                                                <div className="col-6">
                                                    <div className="d-flex align-items-center hover-pointer">
                                                        <img className="img-xs" src={imgUrl} alt="" />
                                                        <div className="ml-2">
                                                            {profile ? (
                                                                <>
                                                                    <p>{profile?.firstName}&nbsp;{profile?.lastName}</p>
                                                                    <p className="text-muted">{profile?.email}</p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <Skeleton variant="text" width="58%" height={13} />
                                                                    <Skeleton variant="text" width="80%" />
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-6 justify-content-end text-right">
                                                </div>
                                            </div>
                                            <hr className='mt-2 ' />
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <b>Previous Surname : </b> </div>
                                                <div className="col-md-6">
                                                    <p>      {profile?.previousName} </p>

                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    {/* <b>Gender at birth  : </b> </div> */}
                                                    <b>What was your sex assigned at birth?  : </b> </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>   {profile?.gendercodeName} </p>
                                                </div>
                                            </div>

                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    {/* <p><b>What gender do you identified as? </b></p> */}
                                                        <p><b>What is your gender? </b></p>
                                                </div>
                                                <div className="col-md-6 ">
                                                {profile?.whatgenderdoyouidentifiedasName}
                                                </div>
                                            </div>

                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>Date of Birth : </b> </div>
                                                <div className="col-md-6">
                                                    <p>{moment(profile?.birthday).format("DD-MMM-YYYY")}</p>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    {/* <b>Occupation : </b>  </div> */}
                                                    <b>What is your job? : </b>  </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>{profile?.occupation}</p>
                                                </div>
                                            </div>
                                            <div className="row pt-2">
                                                <div className="col-md-6 pt-2">
                                                    <b>Preferred Name : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.preferredName} </p>
                                                </div>
                                            </div>
                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <p><b>Relationship status : </b></p>
                                                </div>
                                                <div className="col-md-6 ">
                                                    { profile?.relationShipStatus === 3 ? "Married/Civil Partner to the person having treatment" :   
                                                        profile?.relationShipStatus === 4 ? "Married/Civil Partner to another person not having treatment with " :       
                                                                profile?.relationShipStatus === 5 ? "Divorced/civil partnership dissolved" :
                                                                    profile?.relationShipStatus === 6 ? "Widowed/surviving civil partner" :
                                                                        profile?.relationShipStatus === 2 ? "Separated" :
                                                                        profile?.relationShipStatus === 1 ? "Legally Single" : null}
                                                                        </div>
                                            </div>
                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>Mobile telephone number : </b>
                                                </div>
                                                <div className="col-md-6">
                                                    {profile?.mobileNumber}
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <b>Telephone number : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.homePhone}
                                                    </p>
                                                </div>
                                            </div>

                                              <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>How old are you on the day you are completing this questionnaire?  : </b>
                                                </div>
                                                <div className="col-md-6">
                                                    {profile?.age}
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <b>What pronouns do you prefer : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.bcrm_pronouns}
                                                    </p>
                                                </div>
                                            </div>

                                        </div>
                                        <div className="col-md-6 ">
                                            <h6>Address </h6><br />
                                            <hr />

                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>House No/Flat No. : </b>
                                                </div>
                                                <div className="col-md-6">
                                                    {profile?.patientStreet}
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <b>Street : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.street} </p>
                                                </div>
                                            </div>

                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>City : </b>
                                                </div>
                                                <div className="col-md-6">
                                                    {profile?.city}
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <b>Country : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.country} </p>
                                                </div>
                                            </div>

                                            <div className="row pt-2">
                                                <div className="col-md-6">
                                                    <b>State : </b>
                                                </div>
                                                <div className="col-md-6">
                                                    {profile?.state}
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <b>Zip/Postalcode : </b>
                                                </div>
                                                <div className="col-md-6 pt-2">
                                                    <p>
                                                        {profile?.postalCode} </p>
                                                </div>
                                            </div>
                                            <hr />

                                            <div className="row  mt-2">
                                            <div className="col-md-7">
                                                    <b>Resident In UK Last 12 Months? : </b>
                                                </div>
                                                <div className="col-md-5">
                                                {profile?.residentInUKLast === 271400001 ? "No" :
                                                 profile?.residentInUKLast === 271400000 ? "Yes" : null}
                                                </div>

                                                <div className="col-md-7  mt-2" >
                                                    <b>Ethnicity : </b>
                                                </div>

                                                <div className="col-md-5  mt-2">
                                                {profile?.ethnicity}
                                                </div>
                                            </div>

                                            <div className="row mt-2">
                                            <div className="col-md-7 ">
                                                    <b>Do you speak English well enough to understand a consultation?  : </b>
                                                </div>
                                                <div className="col-md-5  mt-2"  id='cssforthemaindatashow'>
                                                {profile?.bcrm_speakenglish === 271400001 ? "No" :
                                                 profile?.bcrm_speakenglish === 271400000 ? "Yes" : null}
                                                </div>

                                                <div className="col-md-7  mt-2">
                                                    <b>Do you need an interpreter?  : </b>
                                                </div>

                                                <div className="col-md-5  mt-2">
                                                 {profile?.bcrm_needinterpreter === 271400001 ? "No" :
                                                  profile?.bcrm_needinterpreter === 271400000 ? "Yes" : null}
                                                </div>
                                            </div>

                                           {profile?.bcrm_needinterpreter === 271400000 || profile?.bcrm_needinterpreter === '271400000' ?
                                            <div className="row  mt-2">
                                            <div className="col-md-7">
                                                    <b>If you need an interpreter, which language?    : </b>
                                                </div>
                                                <div className="col-md-5 mt-2" >
                                                 {profile?.bcrm_interpreterlanguage}
                                                </div>
                                            </div>
                                            :null}


                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-xl-6 middle-wrapper">
                        <div className="row">
                            <div className="col-md-12 grid-margin">
                                <div className="card rounded border ">
                                    <div className="card-body pb-0">
                                        <div className="row p-2">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col mb-3">
                                                        <h6>Identity :</h6>

                                                    </div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-md-6">
                                                        <p><b>Passport /ID Number : </b>
                                                            {profile?.passportIdNumber}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><b>Country of Issue : </b>
                                                            {profile?.countryOfIssueName} </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>ID Card Type
                                                            : </b>

                                                            {profile?.idCardType === 271400001 ? "NHS" :
                                                            profile?.idCardType === 271400002 ? "CHI" : 
                                                            profile?.idCardType === 271400003 ? "HCN" : 
                                                            profile?.idCardType === 271400004 ? "PSEL" : 
                                                            null}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p>
                                                            {/* <b>NHS/CHI/HCN/PSEL Number : </b> */}
                                                             <b>NHS number : </b>
                                                            {profile?.nhsNumber}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>Place of Birth : </b>
                                                            {profile?.placeOfBirth} </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                      
                                                            {/* <b>Country of Birth : </b> */}
                                                            <b>Were you born in the UK? : </b>
                                                              <p>
                                                                  {profile?.bcrm_borninuk === 271400001 ? "No" :
                                                                   profile?.bcrm_borninuk === 271400000 ? "Yes" : null}
                                                                </p>
                                                    </div>
                                                </div>

                                                 <div className="row pt-2">
                                                    <div className="col-md-6">
                                                      
                                                            {/* <b>Country of Birth : </b> */}
                                                            <b>If you were not born in the UK, where were you born? : </b>
                                                              <p> {profile?.countryOfBirthName} </p>
                                                    </div>

                                                    <div className="col-md-6">
                                                        <p><b>If you were not born in the UK, when did you move to the UK? : </b>
                                                            {/* {moment(profile?.bcrm_datemovedtouk)?.format("DD-MMM-YYYY")} */}
                                                              {profile?.bcrm_datemovedtouk
                                                                ? moment(profile.bcrm_datemovedtouk).format("DD-MMM-YYYY")
                                                                : ""}
                                                             </p>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                        <div className="row">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-md-12 grid-margin">
                                <div className="card rounded border ">
                                    <div className="card-body pb-0">
                                        <div className="row p-2">
                                            <div className="col-md-12">
                                                <div className="row">
                                                    <div className="col mb-3">
                                                        <h6>GP Details</h6>

                                                    </div>
                                                </div>
                                                <div className="row ">
                                                    <div className="col-md-6">
                                                        <p><b>GPs Name : </b>
                                                            {profile?.gPsName}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><b>GP Surgery Name : </b>
                                                            {profile?.gpSurgeryName} </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>GP Telephone Number : </b>
                                                            {profile?.gpTelephoneNumber}</p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><b>GP Email Address : </b>
                                                            {profile?.gp_email}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>GP Street : </b>
                                                            {profile?.gpStreet} </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><b>GP City : </b>
                                                            {profile?.gpCity} </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>GP State/Province : </b>
                                                            {profile?.gpState}
                                                        </p>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <p><b>GP Country/Region : </b>
                                                            {profile?.gpCountry}
                                                        </p>
                                                    </div>
                                                </div>
                                                <div className="row pt-2">
                                                    <div className="col-md-6">
                                                        <p><b>GP ZIP/Postal Code : </b>
                                                            {profile?.gpPostalCode}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <br />
                                        <div className="row">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-md-12 col-xl-12 mt-2 bg-light middle-wrapper">
                        <div className="row">
                            <div className="col-md-4 grid-margin">
                                <div className="card rounded border p-2">
                                    <div className="card-body ">
                                        <div className="row ">
                                            <h6>
                                                Emergency Contacts :
                                            </h6>
                                            <br />
                                        </div>
                                        <div className="row pt-3">
                                            <div className="col-md-8">
                                                <b>  In the event of a medical emergency, please specify emergency contact person :</b>
                                            </div>
                                            <div className="col-md-4">{profile?.intheEventofamedicalEmergencyPleasespecif === 0 ?
                                                "Person with whom you are having treatment" :
                                                profile?.intheEventofamedicalEmergencyPleasespecif === 1 ? "Other" : null
                                            }</div>
                                        </div>
                                        <div className="row pt-2">
                                            <div className="col-md-8">
                                                <b> Emergency Contact Full Name :</b>
                                            </div>
                                            <div className="col-md-4">{profile?.emergencyContactName}</div>
                                        </div>
                                        <div className="row pt-2">
                                            <div className="col-md-8">
                                                <b>Emergency Contact Telephone : </b>
                                            </div>
                                            <div className="col-md-4">{profile?.emergencyContactTelephone}</div>
                                        </div>
                                        <div className="row pt-2">
                                            <div className="col-md-8">
                                                <b>Emergency Contact Relationship :</b>
                                            </div>
                                            <div className="col-md-4">{profile?.emergencyContactRelationship}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-8 grid-margin">
                                <div className="card rounded border">
                                    <div className="card-body">
                                        <h6> This section is required if you are a donor or require a donor for treatment</h6>
                                        <br />
                                        <div className="row">
                                            <div className="col-md-3 mt-1">
                                                <b>Eye Colour :</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.eye_colour_of_the_donor === 1 ? "Blue" :
                                                    profile?.eye_colour_of_the_donor === 2 ? "Brown" :
                                                        profile?.eye_colour_of_the_donor === 3 ? "Green" :
                                                            profile?.eye_colour_of_the_donor === 4 ? "Grey" :
                                                                profile?.eye_colour_of_the_donor === 5 ? "Hazel" :
                                                                    profile?.eye_colour_of_the_donor === 6 ? "Green/Brown" :
                                                                        profile?.eye_colour_of_the_donor === 7 ? "Blue/Grey" :
                                                                            profile?.eye_colour_of_the_donor === 8 ? "Blue/Green" :
                                                                                profile?.eye_colour_of_the_donor === 9 ? "Green/Grey" :
                                                                                    profile?.eye_colour_of_the_donor === 10 ? "Green/Hazel" :
                                                                                        profile?.eye_colour_of_the_donor === 11 ? "Black" :
                                                                                            profile?.eye_colour_of_the_donor === 12 ? "Blue/Green/Grey" :
                                                                                                profile?.eye_colour_of_the_donor === 13 ? "Dark Brown" :
                                                                                                    "None"
                                                }
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Skin Colour :</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.skin_colour_of_donor === 1 ? "Light/Fair" :
                                                    profile?.skin_colour_of_donor === 2 ? "Medium" :
                                                        profile?.skin_colour_of_donor === 3 ? "Dark" :
                                                            profile?.skin_colour_of_donor === 4 ? "Freckles" :
                                                                profile?.skin_colour_of_donor === 5 ? "Olive" : "None"
                                                }
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Natural Hair Colour :</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.natural_hair_colour_of_donor === 1 ? "Black" :
                                                    profile?.natural_hair_colour_of_donor === 2 ? "Blonde Dark" :
                                                        profile?.natural_hair_colour_of_donor === 3 ? "Blonde Light" :
                                                            profile?.natural_hair_colour_of_donor === 4 ? "Brown Dark" :
                                                                profile?.natural_hair_colour_of_donor === 5 ? "Brown Light" :
                                                                    profile?.natural_hair_colour_of_donor === 6 ? "Red" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Ethnic Group of Father</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.ethnic_group_of_donors_father === 1 ? "British" :
                                                    profile?.ethnic_group_of_donors_father === 2 ? "Irish" :
                                                        profile?.ethnic_group_of_donors_father === 3 ? "Any other white background" :
                                                            profile?.ethnic_group_of_donors_father === 4 ? "White and Black Caribbean" :
                                                                profile?.ethnic_group_of_donors_father === 5 ? "White and Black African" :
                                                                    profile?.ethnic_group_of_donors_father === 6 ? "White and Asian" :
                                                                        profile?.ethnic_group_of_donors_father === 7 ? "Any other mixed background" :
                                                                            profile?.ethnic_group_of_donors_father === 8 ? "Indian" :
                                                                                profile?.ethnic_group_of_donors_father === 9 ? "Pakistani" :
                                                                                    profile?.ethnic_group_of_donors_father === 10 ? "Bangladeshi" :
                                                                                        profile?.ethnic_group_of_donors_father === 11 ? "Any other Asian background" :
                                                                                            profile?.ethnic_group_of_donors_father === 12 ? "Caribbean" :
                                                                                                profile?.ethnic_group_of_donors_father === 13 ? "African" :
                                                                                                    profile?.ethnic_group_of_donors_father === 14 ? "Any other Black background" :
                                                                                                        profile?.ethnic_group_of_donors_father === 15 ? "Chinese" :
                                                                                                            profile?.ethnic_group_of_donors_father === 16 ? "Any other ethnic group" :
                                                                                                                profile?.ethnic_group_of_donors_father === 17 ? "Not Stated" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Ethnic Group of Mother</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.ethnic_group_of_donors_mother === 1 ? "British" :
                                                    profile?.ethnic_group_of_donors_mother === 2 ? "Irish" :
                                                        profile?.ethnic_group_of_donors_mother === 3 ? "Any other white background" :
                                                            profile?.ethnic_group_of_donors_mother === 4 ? "White and Black Caribbean" :
                                                                profile?.ethnic_group_of_donors_mother === 5 ? "White and Black African" :
                                                                    profile?.ethnic_group_of_donors_mother === 6 ? "White and Asian" :
                                                                        profile?.ethnic_group_of_donors_mother === 7 ? "Any other mixed background" :
                                                                            profile?.ethnic_group_of_donors_mother === 8 ? "Indian" :
                                                                                profile?.ethnic_group_of_donors_mother === 9 ? "Pakistani" :
                                                                                    profile?.ethnic_group_of_donors_mother === 10 ? "Bangladeshi" :
                                                                                        profile?.ethnic_group_of_donors_mother === 11 ? "Any other Asian background" :
                                                                                            profile?.ethnic_group_of_donors_mother === 12 ? "Caribbean" :
                                                                                                profile?.ethnic_group_of_donors_mother === 13 ? "African" :
                                                                                                    profile?.ethnic_group_of_donors_mother === 14 ? "Any other Black background" :
                                                                                                        profile?.ethnic_group_of_donors_mother === 15 ? "Chinese" :
                                                                                                            profile?.ethnic_group_of_donors_mother === 16 ? "Any other ethnic group" :
                                                                                                                profile?.ethnic_group_of_donors_mother === 17 ? "Not Stated" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Conceived By Donation?</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.wasthedonorconceivedbydonation_os === 271400000 ? "Yes" :
                                                    profile?.wasthedonorconceivedbydonation_os === 271400001 ? "No" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Do you have Biological Children?</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.doesdonorhasownbiologicalchildren_os === 271400000 ? "Yes" :
                                                    profile?.doesdonorhasownbiologicalchildren_os === 271400001 ? "No" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Adopted?</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.wasthedonoradopted_os === 271400000 ? "Yes" :
                                                    profile?.wasthedonoradopted_os === 271400001 ? "No" : "None"}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b>Max Number Families Consented to</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.max_number_families_the_donor_consentedto}
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                <b> Marital Status :</b>
                                            </div>
                                            <div className="col-md-3 mt-1">
                                                {profile?.marital_status === 1 ? "Single" :
                                                    profile?.marital_status === 2 ? "Married, in civil partnership" :
                                                        profile?.marital_status === 3 ? "Divorced, person whose civil partnership has been dissolved" :
                                                            profile?.marital_status === 4 ? "Widowed, surviving civil partner" :
                                                                profile?.marital_status === 5 ? "Separated" :
                                                                    profile?.marital_status === 6 ? "Not disclosed" : "None"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>


                </div>
            </div>
        </div >
    )
}